/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Deduct_On_Packing_DescInputs */

const vi_packaging_material_deduct_on_packing_desc = /** @type {(inputs: Packaging_Material_Deduct_On_Packing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộp, nhãn, túi hút chân không — thứ nằm trong sản phẩm.`)
};

/**

* @param {Packaging_Material_Deduct_On_Packing_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_deduct_on_packing_desc = /** @type {((inputs?: Packaging_Material_Deduct_On_Packing_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Deduct_On_Packing_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_deduct_on_packing_desc(inputs)
});